App.addModule(function(app) {

    window.onAmazonPaymentsLoaded = function() {
	    
        app.on('form:submitted', (form, ok, result) => {

	        if (ok && form.classList.contains('form-addtocart')) {
		        AmazonPayments.renderButtons()
	        }
        })

        if (app.get('app.request.path') !== 'amazonpayments/checkout/index') {
            return
        }

	    $('#oscheckout-shipping-method-form').off('submit');
	    
	    $('#checkout-section-cart').on('click', '#place-order-button', function() {
		    AmazonPayments.saveOrder();
	    });
	    
	    AmazonPayments.setCallbacks({
		    
		    onShippingAddressSelectStart: function() {
			    $('.checkout-section .loader:not(#place-order-loader)').show();
		    },
		    
		    onShippingAddressSelectSuccess: function() {
			    
			    $('.checkout-section .loader:not(#place-order-loader)').hide();
			    
			    $('.fg-shipping-method a[data-toggle="tab"]').on('show.bs.tab', function() {
				    
				    if ($(this).parent().hasClass('active')) {
					    return;
				    }
				    
				    var input = $(this).children('input[name="shipping_method"]');
				    
				    if (input.val() == 'flex_service' && $('#flex-service-plus').prop('checked')) {
					    input = $('#s_method_flex_service_plus input');
				    }
				    
				    input.prop('checked', true).change();
			    });
			    
			    $('#flex-service-plus').on('change', function() {
				    if (this.checked) {
					    $('#s_method_flex_service_plus input').prop('checked', true).change();
				    }
				    else {
					    $('#s_method_flex_service input').prop('checked', true).change();
				    }
			    });
			    
			    if ($('#s_method_flex_service_plus input').prop('checked')) {
				    $('#flex-service-plus').prop('checked', true);
				    $('#s_method_flex_service a').tab('show');
			    }
		    },
		    
		    onShippingAddressSelectError: function() {
			    $('.checkout-section .loader:not(#place-order-loader)').hide();
		    },
		    
		    onShippingMethodSelectStart: function() {
			    $('#checkout-section-cart .loader:not(#place-order-loader)').show();
		    },
		    
		    onShippingMethodSelectSuccess: function() {
			    $('#checkout-section-cart .loader:not(#place-order-loader)').hide();
		    },
		    
		    onShippingMethodSelectError: function() {
			    $('#checkout-section-cart .loader:not(#place-order-loader)').hide();
		    },
		    
		    onSaveOrderStart: function() {
			    $('#place-order-loader').show();
		    },
		    
		    onSaveOrderSuccess: function() {
			    $('#place-order-loader').hide();
		    },
		    
		    onSaveOrderError: function() {
			    $('#place-order-loader').hide();
		    }
	    });
    };
})
